export class GraphqlError extends Error {
  constructor(message, response) {
    super(message);
    this.name = "GraphqlError";
    this.originalError = response.data.errors[0];
    this.response = response;
  }
}

export class GraphqlAccessDeniedError extends GraphqlError {
  constructor(message, response) {
    super(message, response);
    this.name = "GraphqlAccessDeniedError";
  }
}
